import { render } from "./ScatterPlotView.vue?vue&type=template&id=5ebd2952"
import script from "./ScatterPlotView.vue?vue&type=script&lang=js"
export * from "./ScatterPlotView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__